module.exports = __webpack_public_path__ + "static/media/ic_share_deactivate.d18595f0.svg";